export enum FormType {
    Reactive = 'reactive',
    Template = 'template'
}